<template>
	<div class="admin-landing">
		<transition mode="out-in">
			<div class="section-content centered" key="admin-landing-page">
				<h1>Money Guided Admin Home</h1>
				<p>Choose what you would like to do from the side menu</p>
				<p>This is Peg. Peg says "Hi".</p>
				<p>She will now read your fortune... please wait...</p>
				<img :src="require('@/admin/assets/WomanMGChill.svg')" class="peg-image" />
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'AdminLandingPage',
	mounted() {
		console.log('Admin Landing Page loaded');
	}
}
</script>

<style scoped>
.admin-landing {
	width: 100%;
}

.section-content {
	animation: fadeIn 0.3s ease-in;
}

.section-content.centered {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	text-align: center;
	min-height: 400px;
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

.section-content h1 {
	margin-top: 0;
	margin-bottom: 20px;
	font-size: 28px;
	color: var(--admin-text-primary);
	transition: color 0.3s ease;
}

.section-content p {
	color: var(--admin-text-secondary);
	font-size: 14px;
	transition: color 0.3s ease;
}

.peg-image {
	max-width: 300px;
	width: 100%;
	height: auto;
	margin-top: auto;
	margin-bottom: -267px;
}

@media (max-width: 768px) {
	.section-content h1 {
		font-size: 22px;
	}
}

@media (max-width: 480px) {
	.section-content h1 {
		font-size: 20px;
		margin-bottom: 15px;
	}
}
</style>
